/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useDevice } from '@squiz/dxp-console-support';
import clsx from 'clsx';
import React, { useRef } from 'react';
import { SideNavSection } from './elements/SideNavSection';
import { sideNavDefaults, SideNavProps } from './SideNav.props';

/**
 * SDS SideNav component.
 */
export const SideNav = (props: SideNavProps): JSX.Element => {
  const { classes, menuHeading, sections, ...rest } = {
    ...sideNavDefaults,
    ...props,
  };

  const menuRef = useRef<HTMLElement>(null);
  const menuClass = clsx(`sds-sidenav`, classes);

  // Device detection
  const deviceType = useDevice();

  const getMenuSections = (): Array<JSX.Element> => {
    return sections.map((section): JSX.Element => {
      // Don't display the section if it's not meant for this device
      if (section.devices && !section.devices.includes(deviceType)) {
        return <React.Fragment key={section.key}></React.Fragment>;
      }
      return (
        <React.Fragment key={section.key}>
          <SideNavSection menuSection={section} />
        </React.Fragment>
      );
    });
  };

  // eslint-disable jsx-a11y/no-noninteractive-tabindex
  return (
    <nav className={menuClass} ref={menuRef} tabIndex={-1} {...rest}>
      <h2 className="sr-only">{menuHeading}</h2>
      {getMenuSections()}
    </nav>
  );
};
